import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {getAllQuests, User} from "../services/player.ts";
import React, {useEffect, useState} from "react";
import {Quest} from "../services/quest.ts";
import {Achievement, getAchievements} from "../services/achivement.ts";
import "./Account.css";
import {useSwipeable} from "react-swipeable";

type AccountProps = {
    user: User;
}

export default function Account({user}: AccountProps): React.JSX.Element {
    const [quests, setQuests] = useState<Quest[]>([]);

    useEffect(() => {
        setQuests(getAllQuests(user));
    }, [user]);

    const [achievements, setAchievements] = useState<Achievement[] | null>(null);

    useEffect(() => {
        (async () => {
            setAchievements(await getAchievements(user));
        })();
    }, [user]);

    const [tabIndex, setTabIndex] = useState(0);
    const tabsCount = 3; // Общее количество ваших табов

    const handlers = useSwipeable({
        onSwipedLeft: () => setTabIndex((prev) => Math.min(prev + 1, tabsCount - 1)),
        onSwipedRight: () => setTabIndex((prev) => Math.max(prev - 1, 0)),
        preventScrollOnSwipe: true,
        touchEventOptions: { passive: true }
    });

    return <div {...handlers} style={{ overflowX: "hidden", height: "100%", touchAction: "pan-x" }}>
        <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
        >
            <TabList>
                <Tab>Квесты</Tab>
                <Tab>Достижения</Tab>
            </TabList>

            <TabPanel>
                {
                    quests.length !== 0
                        ? quests.map(quest => <div key={quest.id}>{quest.title}</div>)
                        : <p style={{textAlign: "center", display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "center"}}>
                            Активных квестов пока что нет. <br />
                            Подойди к точке на карте, чтобы начать свой первый квест.
                        </p>

                }
            </TabPanel>
            <TabPanel>
                {
                    achievements !== null
                        ? <dl>
                                {achievements.map(achievement =>
                                <div key={achievement.id} className={["achievement", "achievement_" + achievement.state].join(" ")}>
                                    <dt>{achievement.title}</dt>
                                    <dd>{achievement.description}</dd>
                                </div>
                            )}
                        </dl>
                        : <p style={{textAlign: "center", marginBlockStart: "4rem"}}>
                            Загрузка достжений...
                        </p>

                }
            </TabPanel>
        </Tabs>
    </div>;
}